import React from 'react'

import { Circle, Rect } from 'react-konva'

import { ANNOTATION_TYPE } from '../utils/annotationUtils'

interface AnnotationShapeProps {
  annotation: any
  isDraggable: boolean
  onClick: (e: any) => void
  strokeColor?: string
  strokeWidth?: number
}

export const AnnotationShape: React.FC<AnnotationShapeProps> = ({
  annotation,
  isDraggable,
  onClick,
  strokeColor = "#763fc1",
  strokeWidth = 2
}) => {
  const { id, x, y, width, height, type, fillColor } = annotation

  if (type === ANNOTATION_TYPE.RECTANGLE) {
    return (
      <Rect
        data-info={annotation}
        id={id}
        key={id}
        x={x}
        y={y}
        stroke={strokeColor}
        strokeWidth={strokeWidth}
        height={height}
        width={width}
        draggable={isDraggable}
        onClick={onClick}
      />
    )
  }

  if (type === ANNOTATION_TYPE.POINT) {
    return (
      <Circle
        id={id}
        key={id}
        x={x}
        y={y}
        radius={4}
        stroke={strokeColor}
        strokeWidth={strokeWidth}
        fill={fillColor}
        draggable={isDraggable}
        onClick={onClick}
      />
    )
  }

  return null
}
